import Vue from 'vue'
import Loading from './Loading.vue'
const LoadingConstructor = Vue.extend(Loading)
const options = {
    data() {
        return {}
    },
    mounted() {
        // this.fn1(1)
    },
    methods: {
        fn1(val) {
            // this.a = 3333
            // console.log('fn1', val)
        }
    },
    watch: {
        // a(val) {
        // }
    }
}
// options 内部同组件内部生命周期一样，但组件内部优先执行
const instance = new LoadingConstructor(options)
instance.$mount()
document.body.appendChild(instance.$el)
export default function install() {
    Vue.prototype.$Loading = instance
}